import React, { useMemo, useState } from 'react';
import Modal from '../common/Modal';
import Button from '../common/Button';
import { useWallet } from '../../context/WalletContext';
import { useContractState } from '../../context/ContractContext';
import { useNotify } from '../../context/NotificationContext';
import { getADNFTContract } from '../../web3/contractInstance';
import { parseContractError } from '../../utils/errors';
import { formatUSDT, toNumberSafe, bpToPct } from '../../utils/format';
import { validateClaim } from '../../utils/validators';
import { toUnits } from '../../web3/providerHelper';
import FullScreenLoader from '../loader/FullScreenLoader';

export default function ClaimModal({ open, onClose }) {
  const { getSigner } = useWallet();
  const { basic, limits, fees, refresh } = useContractState();
  const notify = useNotify();
  const [amount, setAmount] = useState('');
  const [busy, setBusy] = useState(false);

  const pending = basic ? basic.pendingRewards : 0;
  const min = limits ? toNumberSafe(limits.minClaim) : 10;
  const err = useMemo(() => validateClaim(amount || '0', pending, limits && limits.minClaim), [amount, pending, limits]);

  async function submit(all = false) {
    const signer = getSigner();
    if (!signer) { notify.error('Wallet not ready'); return; }
    setBusy(true);
    try {
      const c = getADNFTContract(signer);
      const value = all ? '0' : String(amount || '0');
      const tx = await c.claimRewards(value === '0' ? 0 : toUnits(value));
      await tx.wait();
      notify.success('Rewards claimed', all ? 'Full pending withdrawn' : `$${amount} withdrawn`);
      setAmount('');
      refresh();
      onClose();
    } catch (e) {
      notify.error('Claim failed', parseContractError(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Modal open={open} onClose={onClose} title="Claim Rewards" subtitle={`Available: ${formatUSDT(pending)} · Fee: ${fees ? bpToPct(fees.claimFee) : '10%'}`}>
      <div className="field">
        <label>Amount (USDT)</label>
        <div className="input-suffix">
          <input
            className="input"
            type="number"
            inputMode="decimal"
            placeholder={`min $${min}`}
            value={amount}
            onChange={e => setAmount(e.target.value)}
          />
          <span className="suffix">USDT</span>
        </div>
        {err && <div className="error-msg">⚠ {err}</div>}
      </div>
      <div className="modal-actions">
        <Button variant="ghost" block onClick={() => submit(true)} loading={busy}>Claim All</Button>
        <Button variant="primary" block onClick={() => submit(false)} loading={busy} disabled={!amount || !!err}>
          Claim Amount
        </Button>
      </div>
      {busy && <FullScreenLoader message="Claiming rewards…" sub="Confirm in your wallet" />}
    </Modal>
  );
}
